import { jsx } from "react/jsx-runtime";
import { cn } from "@tameeni/shared-logic";
import * as React from "react";
const Card = React.forwardRef(({ className, gradientBorderColor, ...props }, ref) => {
  const commonContent = /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: cn(
        "border bg-card text-card-foreground gap-2 lg:gap-4 flex flex-col overflow-hidden @container",
        gradientBorderColor ? "w-full h-full border-none shadow-none" : "rounded-md",
        className
      ),
      ...props
    }
  );
  return gradientBorderColor ? /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        gradientBorderColor,
        "p-px center",
        props.containerClassName
      ),
      children: commonContent
    }
  ) : commonContent;
});
Card.displayName = "Card";
const CardHeader = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("flex flex-col px-3 lg:px-4", className),
    ...props
  }
));
CardHeader.displayName = "CardHeader";
const CardTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("font-semibold leading-none tracking-tight", className),
    ...props
  }
));
CardTitle.displayName = "CardTitle";
const CardDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("text-sm text-muted-foreground", className),
    ...props
  }
));
CardDescription.displayName = "CardDescription";
const CardContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("px-3 lg:px-4 pt-0", className), ...props }));
CardContent.displayName = "CardContent";
const CardFooter = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("flex items-center", className), ...props }));
CardFooter.displayName = "CardFooter";
export {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
};
